import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProfessionalProfile from "../../(User)Profile_Final/index.js";
import Mo3tiSalaryPage from "../../(User)salary_Final/index.js";
import Mo3tiAttendancePage from "../../(User)attendance_page/index.js";
import Mo3tiDocumentsPage from "../../(User)SelfService/index.js";
import Calendar from '../../(All) Calendar/index.jsx';
import Mo3tiLeavePage from "../../(User)leave_Managment/index.js";
import Mo3tiSettingsPage from "../../(All) settings/index.js";
import MessengerPage from "../../(All) messenger/MessengerPage.jsx";
import EscalationPage from "../../(User)EscalationComplaints/index.jsx";
import GroupsManagement from "../../(user) GroupsManagement/index.jsx";
import LocationGuard from "../components/LocationGuard.jsx";
import ClientModuleGuard, { SELF_SERVICE_PAGE_MODULES } from "../../../components/ClientModuleGuard.jsx";

// Off for the client → hidden fully, so the URL redirects to the profile.
const guard = (page, element) => (
  <ClientModuleGuard
    module={SELF_SERVICE_PAGE_MODULES[page] || null}
    redirectTo="/userprofile/professionalProfile"
  >
    {element}
  </ClientModuleGuard>
);

const UserRoutes = ({ pageProps, isPrivateMessagingEnabled, toggleTheme, userLocation, locationError, t }) => (
  <Routes>
    <Route path="/" element={<ProfessionalProfile />} />
    <Route path="/professionalProfile" element={<ProfessionalProfile />} />
    <Route path="/salary" element={guard("salary", <Mo3tiSalaryPage {...pageProps} />)} />
    <Route path="/escalation" element={guard("escalation", <EscalationPage {...pageProps} />)} />
    <Route path="/groups" element={guard("groups", <GroupsManagement />)} />
    <Route path="/attendance" element={guard("attendance", <Mo3tiAttendancePage {...pageProps} />)} />
    <Route path="/employee-services" element={guard("employee-services", <Mo3tiDocumentsPage {...pageProps} />)} />
    <Route path="/calendar" element={guard("calendar", <Calendar {...pageProps} />)} />
    <Route
      path="/messages"
      element={
        isPrivateMessagingEnabled ? (
            <MessengerPage />
        ) : (
          <Navigate to="/userprofile" replace />
        )
      }
    />
    <Route path="/leave-management" element={guard("leave-management", <Mo3tiLeavePage {...pageProps} />)} />
    <Route path="/settings" element={<Mo3tiSettingsPage {...pageProps} toggleTheme={toggleTheme} />} />
    <Route path="*" element={<Navigate to="/userprofile/professionalProfile" replace />} />
  </Routes>
);

export default UserRoutes;